import script from "./CardObject.vue?vue&type=script&setup=true&lang=js"
export * from "./CardObject.vue?vue&type=script&setup=true&lang=js"

import "./CardObject.vue?vue&type=style&index=0&id=4df35b55&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df35b55"]])

export default __exports__